import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SkillsDialogService} from "../../services/skills-dialog.service";
import {SkillsService} from "../../services/skills-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class SkillsViewCtrl implements IController {

  skills: any;

  private filterConfig: any;
  private filteredSkills: any;

  /* @ngInject */
  constructor(private skillsDialogService: SkillsDialogService, private confirmDialogService: ConfirmDialogService, private $log, private skillsService: SkillsService) {}

  $onInit() {

    this.filterConfig = {
      queryString: undefined
    };
    this.filteredSkills = angular.copy(this.skills);
  };

  //////////////////////////////////////////////////////////////////////////

  // ******************************
  //        Public methods
  // ******************************

  onSearchQueryChange(query) {
    this.filterConfig.queryString = query;
    this.filteredSkills = this._getFilteredSkills(this.skills, query);
  }

  onCreateSkill($event) {
    this.skillsDialogService.create(this.skills, $event)
      .then((skill) => {
        this._createSkill(skill);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to create skill @skillsView@onCreateSkill', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onEditSkill(skill, $event) {
    this.skillsDialogService.edit(skill, $event)
      .then((editedSkill) => {
        this._updateSkil(editedSkill);
      })
      .catch((error) =>{
        if (error) {
          this.$log.error('Failed to edit skill @skillsView@onEditSkill', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onSkillActiveChange(skill) {
    this.skillsService.updateActiveOne(skill)
      .then((updatedSkill) => {
        const skillIndex = _.findIndex(this.skills, (s: any) => {
          return s.id === skill.id
        });
        if (skillIndex !== -1) {
          this.skills[skillIndex] = updatedSkill;
          this.filteredSkills = this._getFilteredSkills(this.skills, this.filterConfig.queryString);
        }
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  _createSkill(skill) {
    this.skillsService.createOne(skill)
      .then((createdSkill) => {
        this.skills.push(createdSkill);
        this.filteredSkills = this._getFilteredSkills(this.skills, this.filterConfig.queryString);
      })
  }

  _updateSkil(skill) {
    this.skillsService.updateOne(skill)
      .then((updatedSkill) => {
        const skillIndex = _.findIndex(this.skills, (s: any) => {
          return s.id === skill.id
        });
        if (skillIndex !== -1) {
          this.skills[skillIndex] = updatedSkill;
          this.filteredSkills = this._getFilteredSkills(this.skills, this.filterConfig.queryString);
        }
      })
  }

  _getFilteredSkills(skills, query) {
    return _.filter(skills, (s) => {
      const skillNameLowerCase = s.name.toLowerCase();
      return query ? skillNameLowerCase.includes(query.toLowerCase()) : true;
    });
  }


}
angular
  .module('bringoz.admin.skills')
  .component('skillsView', {
    bindings: {
      skills: '<'
    },
    template: require('./skills-view.html').default,
    controller: SkillsViewCtrl
  });
